import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingRecraftAiImageGeneratorConfig } from '@/data/landingConfig/landingRecraftAiImageGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_RecraftAiImageGenerator } from './schemaObject';

interface Props {}
const RecraftAiImageGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_RecraftAiImageGenerator} />
			<LandingTemplate
				data={landingRecraftAiImageGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default RecraftAiImageGenerator;
